import React from "react";
import { motion } from "framer-motion";
import DOMPurify from "dompurify";
import { usePageHeaderByKey } from "../hooks/usePageHeaderBykey";
import PublicPageShell from "../components/PublicPageShell";

const FreeList = () => {
  const { pageHeader, isLoading } = usePageHeaderByKey("free");
  const safeHtml = pageHeader?.content
    ? DOMPurify.sanitize(pageHeader.content, {
        ADD_ATTR: ["style", "class", "target"],
      })
    : "";

  return (
    <PublicPageShell className="text-[#003049] pt-0">
      <div className="flex flex-col justify-center w-full">
        {isLoading ? (
          <div className="flex justify-center py-12">
            <div className="animate-spin w-10 h-10 border-2 border-[#BA1500] border-t-transparent rounded-full" />
          </div>
        ) : safeHtml ? (
          <div className="rich-text-content current-promotions-content w-full bg-white rounded-lg border border-[#e5e7eb] shadow-md p-4 lg:p-6 text-[#003049]">
            <motion.h1
              initial={{ opacity: 0, y: -30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="current-promotions-page-title text-xl mb-2 mt-0 text-left font-bold text-[#003049] uppercase w-full"
            >
              {pageHeader?.h1 || "Free"}
            </motion.h1>
            {pageHeader?.tagline && (
              <p className="mb-6 text-left text-gray-700 md:text-sm leading-relaxed">
                {pageHeader.tagline}
              </p>
            )}
            <div
              dangerouslySetInnerHTML={{ __html: safeHtml }}
            />
          </div>
        ) : (
          <>
            <motion.h1
              initial={{ opacity: 0, y: -30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="current-promotions-page-title text-xl mb-2 mt-0 text-left font-bold text-[#003049] uppercase w-full"
            >
              {pageHeader?.h1 || "Free"}
            </motion.h1>
            <p className="text-left text-gray-600 py-12">
              No free information available yet.
            </p>
          </>
        )}
      </div>
    </PublicPageShell>
  );
};

export default FreeList;
